 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		111: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_vi","52":"lang_zh_cn","53":"lang_zh_tw","54":"locale_ak","55":"locale_ar","56":"locale_be","57":"locale_bg","58":"locale_bs","59":"locale_ca","60":"locale_cs","61":"locale_da","62":"locale_de","63":"locale_el","64":"locale_en","65":"locale_es","66":"locale_et","67":"locale_fi","68":"locale_fil","69":"locale_fr","70":"locale_he","71":"locale_hi","72":"locale_hr","73":"locale_hu","74":"locale_id","75":"locale_is","76":"locale_it","77":"locale_ja","78":"locale_ka","79":"locale_kk","80":"locale_ko","81":"locale_ky","82":"locale_lt","83":"locale_lv","84":"locale_nl","85":"locale_pa","86":"locale_pl","87":"locale_pt","88":"locale_ro","89":"locale_ru","90":"locale_sk","91":"locale_sl","92":"locale_sq","93":"locale_sr","94":"locale_sr_cyrl_me","95":"locale_sv","96":"locale_sw","97":"locale_th","98":"locale_tr","99":"locale_uk","100":"locale_ur","101":"locale_vi","102":"locale_zh","103":"loclae_af","104":"polyfills","106":"vendors~css-vars-ponyfill","107":"vendors~dompurify","108":"vendors~marked","109":"vendors~polyfills"}[chunkId]||chunkId) + "." + {"0":"3dd231b67f4347a36f75","2":"a6ca7893df988be5cf83","3":"89ececab86f65e7af3f2","4":"88807b905e24fbd7e073","5":"bfa20408ab24e5073d26","6":"60e7b29b2fba8eb801f7","7":"a8dc8fe2990959b294d3","8":"c26860744d6deff19b36","9":"c76d6a652dcf1f5e13ba","10":"165aa7cda773aceea893","11":"b111ff47d17653e7d675","12":"242dea5757013be09d93","13":"e510a290dfd073a6633e","14":"986b030bcfd50ae70204","15":"f652093e7a94c98295bd","16":"b10a81b29648e5959851","17":"351f86fb96ee24cbd844","18":"278a8c6df760748f5b48","19":"fb000c22d1f946838f2c","20":"14b79b9947682bae0146","21":"272daed5be6c0fe55642","22":"32873513c249225950e1","23":"48cbc0f2f128977ebc6d","24":"f655134a8f767f44eb8b","25":"b2576840f3094f1a6363","26":"9ba2f348327936a8d3dc","27":"49c5b337050c654937a0","28":"5e67fca4dc459b138c13","29":"ac44cae59ddf293a0319","30":"8dc16df9fac7be50ce93","31":"5312528fe64f5bb8d9aa","32":"fa3ea7b406258eaf8cd6","33":"8451dca7565c82bde02b","34":"01573f5f4cccd9de3da6","35":"0a428fbd5d268c8e3698","36":"19b37a6af700a9e03a98","37":"9ee5792715f1910ceef7","38":"605e5dd4b3d135845063","39":"58c6417b768cd59676cd","40":"3cdf0710f592287b232f","41":"ec5365282b22cd8d7be5","42":"7b990e8496d13d12b61c","43":"625d9173edc2b1703371","44":"6b47fde632a8a472ca31","45":"f2e97a8dd8dca5b23ea2","46":"5a665aea26edea3a62c5","47":"0b97cbef30b7ce700d69","48":"3921056ae032e72c5fa5","49":"c71fa5cb081744018e32","50":"adfa9cbbb27210076da6","51":"680ea030792b65551ced","52":"2a1f3e2fb52124f3a66e","53":"61cdbcf303386e6ad286","54":"8c230c51958c2099d4be","55":"5ffb1d9436fb5472ffba","56":"305a2d4f7a1063b27231","57":"9879297a3c573e723d07","58":"9809fd703bc766b0c59f","59":"64a949ef28e329e10f49","60":"6df5ecb1049125023fa7","61":"6f22c07260c947721cb3","62":"b27377304640ed28dc48","63":"09fb78bb3a08d9d0cb96","64":"53e4295638c679f12e04","65":"63d486462d2a7a5c08f0","66":"9f1c246e86fb644eb784","67":"0666c6ea0899f4d4649b","68":"8554c2baaee3cc2a4a5d","69":"7dd2182770e0c8bbcc4c","70":"9e1b556f81fc8e454f12","71":"8570f4381d88665f6fcf","72":"73701bed3eb7e3acfd6f","73":"1a6088cd166d368936a7","74":"c8c5fe175ea3341b3deb","75":"6761e877d4fad87ff12b","76":"697045a179bfb9e3dc81","77":"4aedcbceb6b751f92af6","78":"ed20b9a3643d12a77bd1","79":"e4a8f0b5f32cbf19d3b6","80":"26be51c4bc353f27c0dd","81":"55f39f9136abf342e524","82":"aa34a7fdc6e0ad1e231c","83":"5d234d12dcfc2fa4834d","84":"e55b7b84c98177e16517","85":"3c2d52d1798ebcea1730","86":"bdce28896fa68134b1d4","87":"ef655ddc354b4411b3fb","88":"1fc2b2aeda2566ac9d54","89":"1e2ab4d72f1178bb8444","90":"37ed92a98cb67a789740","91":"687508c09a28dd7fa555","92":"456c0bf69108a93dc193","93":"054605b6f26ffaacd77b","94":"da7701db562bdb911822","95":"30ab48b5b2af9533b155","96":"5a56a354888a1430d72e","97":"e8571abfbb3fc6437117","98":"5541d398266b7b9001ae","99":"3a708379c60fa10ffb55","100":"148c594b1ba59fa1b772","101":"79917f9e0ff8fe626550","102":"7abd797ed6aa05fc7b81","103":"f732b43713b5f0bb34a1","104":"becdb5b77172ce64da35","106":"cf2008c763a2acdfb369","107":"bf83f7dd0b880f6967ac","108":"1ee9760dd270c09af4be","109":"84e90f701a9cc6e3a51f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/release-v0.1.167/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 83);
